// extracted by mini-css-extract-plugin
module.exports = {"button":"TranslationControlsButton_button__s543N","active":"TranslationControlsButton_active__2LBjy"};